// CvoModel.js
// 공통으로 사용하는 데이터.

import { makeVar } from "@apollo/client";
import { AppObject } from "./AppConst";
import UserSessionInfo from "../com/common/UserSessionInfo";

export const NoUser = new UserSessionInfo(true, false, {});
const NoSessionCheckd = new UserSessionInfo(false, false, {}); // {...NoUser, sessionChecked: false};
export const custListRepo = makeVar([]); // for admin only.
export const userInfoRepo = makeVar(NoSessionCheckd);
export const codeTreeRepo = makeVar([]);
export const currentMenuRepo = makeVar(AppObject.DefaultMenu);
export const menuTreeRepo = makeVar([]);
export const appAlertRepo = makeVar([]);

// 한시적 설정.
export const showRouteMonthlyActiveOnlyRepo = makeVar(false); // true === totalDist > 0 인 것만 보기.

// for FlexyTable
export const tableShapeConfRepo = makeVar({}); // veh_pos: {columns:[{id,width}], saved:true}
export const openTableShapeConfRepo = makeVar(false);

// 2025.8.29 이후.
export const smsMessageListRepo = makeVar([]); // for SMS messages
export const smsMessageReloadSignalRepo = makeVar({count:0, from: null, till: null});
export const smsPhraseListRepo = makeVar([]); // for SMS phrases
export const vehInfoListRepo = makeVar([]); // for vehicle info
export const addressInfoListRepo = makeVar([]); // for address info
export const userInfoListRepo = makeVar([]); // for user info
export const smsSentListRepo = makeVar([]); // for sms sent, group by cust_id.
export const vehFilterListsRepo = makeVar({ // 차량필터링 데이터(Tree, List 등)
    when:0,
    custAgreeList:[], // dataList.custAgreeList
    vehTonInfoList:[], // dataList.vehTonInfoList
    vehGroupList:[], // dataList.vehGroupList
    groupVehAllocList:[] // dataList.groupVehAllocList
});
export const vehPosFilterCriteriaRepo = makeVar({criteria:null, filterData: null}); // veh-pos-repeat

// Help. 2025.9.9
export const helpTopicRepo = makeVar({key:null, component: null});

// for map
export const vehPosRepo = makeVar({when:0, records:[]}); // 수신한 모든 차량위치.
export const vehPosFilteredRepo = makeVar([]); // for map to display
export const vehFilterForMapCriteriaRepo = makeVar({criteria:null, filterData: null});
export const vehPosSearchRepo = makeVar('');
export const poiTypeRepo = makeVar([]); // for map
export const poiInfoRepo = makeVar([]); // for map
export const sweeperStatRepo = makeVar([]); // for map. 탭 선택할 때마다 다시 가져오지 않도록.
export const sweeperSelectedRepo = makeVar(null);
export const sweeperRouteRepo = makeVar([]); // global. 탭 선택할 때마다 다시 가져오지 않도록.
export const overlapRepo = makeVar(null); // map shell to MapMain. // 차량, POI, 클러스터 간략한 팝업정보 보여주기 위한 데이터. {x, y, records}
export const poiPositionRepo = makeVar(null); // 안쓰는 듯. poi position 전달용.(map to MapMain to view)
//export const polygonRepo = makeVar([]); // 폴리곤 편집 상태를 지도에서 view로 전달.
export const poiEditCommandRepo = makeVar(null);
export const naverSearchResultRepo = makeVar([]); 
export const naverSearchRepo = makeVar('');
export const naverRouteRepo = makeVar([]); // 경로탐색 결과. 클래스 NaverRoute
export const mapLinkInfoRepo = makeVar(null); // 지도 링크 지시.

// for logging in memory.
export const logRepo = makeVar([]); // {time, message} - only admin can see.

export function clearLog() {
    logRepo([]);
}

export function mmlog(message) {
    const logs = logRepo();
    if(logs.length > 500) logs.splice(0, logs.length - 500);
    logs.push({time: new Date(), message: message});
    logRepo([...logs]);

    const sessionInfo = userInfoRepo();
    if(sessionInfo.isSystemAdmin() || sessionInfo.user.userId==='etrace') {
        console.log(message);
    }
}

export function hasDataError(InputMap, data, inputError, isEdit) {
    for(const id of Object.keys(InputMap)) {
        const imap = InputMap[id];
        const needAction = isEdit ? imap.toEdit : imap.toAdd;
        if(inputError[id]) {
            // 어떤 필드라도 오류가 있는지 검사.
            return true;
        }
        else if(needAction) {
            if(imap.required) {
                if(!data.hasOwnProperty(id)
                    || data[id]===undefined
                    || data[id]===null
                    || data[id]===''
                ) {
                    //mmlog('hasDataError: Missing required field:' + id);
                    return true;
                }
            }
            else if(data.hasOwnProperty(id)) {
                if(imap.check && !imap.check(data[id])) {
                    //mmlog('hasDataError: Error in field:' + id);
                    return true;
                }
            }
        }
    }
    return false;
}

export function checkAllError(InputMap, data, inputError, isEdit) {
    const errorKeys = [];
    for(const id of Object.keys(InputMap)) {
        const imap = InputMap[id];
        const needAction = isEdit ? imap.toEdit : imap.toAdd;
        if(inputError[id]) {
            errorKeys.push(id);
        }
        else if(needAction) {
            if(imap.required) {
                if(!data.hasOwnProperty(id)
                    || data[id]===undefined
                    || data[id]===null
                    || data[id]===''
                ) {
                    errorKeys.push(id);
                    //mmlog('checkAllError: Missing required field:' + id);
                }
                else if(imap.check && !imap.check(data[id])) {
                    errorKeys.push(id);
                    //mmlog('checkAllError: Error in field required:' + id);
                }
            }
            else if(data[id] !== undefined && data[id] !== null && data[id] !== '' && imap.check && !imap.check(data[id])) {
                errorKeys.push(id);
                //mmlog('checkAllError: Error in field not required:' + id);
            }
        }
    }
    return errorKeys;
}

export function reflectInput(id, value, InputMap, inputData, inputError, isEdit) {
        const dataInfo = InputMap[id]; // {id, label, type, required, toAdd, toEdit, help, check}

        const er = {...inputError};
        let hasError = false;

        if(dataInfo.check && !dataInfo.check(value)) {
            er[id] = true; // dataInfo.help;
            hasError = true;
            mmlog('Error in field:' + id + ' value=' + value + ' type=' + typeof(value));
        }
        else {
            // remove id from errors
            if(er[id]) {
                delete er[id];
            }
        }

        const data = {...inputData};
        data[id] = value;

        const errorKeys = checkAllError(InputMap, data, er, isEdit);
        if(errorKeys.length > 0) hasError = true;
    
        er.__errorKeys = errorKeys;
        er.__errorLabels = errorKeys.filter(v => InputMap[v] && InputMap[v].label).map(v => InputMap[v].label);
        
        return [data, er, hasError];
}

export function reflectInputEvent(event, InputMap, inputData, inputError, isEdit) {
    return reflectInput(event.target.id, event.target.value, InputMap, inputData, inputError, isEdit);
}

export function getLabelsForError(inputError, InputMap) {
    const labels = [];
    for(const id of Object.keys(inputError)) {
        if(inputError[id]) {
            const dataInfo = InputMap[id];
            if(dataInfo && dataInfo.label) labels.push(dataInfo.label);
            else {
                mmlog('No label for error field:' + id);
            }
        }
    }
    return labels;
}
